import type { WidgetSize } from './types';

export const GRID_COLS = 12;
export const ROW_H = 64;
// Gap between widgets: equals --container-gap in index.css (the one container gap).
export const GAP = 2;
// Customize-mode dotted grid subdivision: dots per cell on each axis. 1 => one dot
// at every cell corner (the edge lattice widgets snap to). Purely decorative.
export const DOT_SUBDIV = 1;

const SIZE_WH: Record<WidgetSize, { w: number; h: number }> = {
  S: { w: 4, h: 3 }, M: { w: 8, h: 3 }, L: { w: 12, h: 4 },
};

const clampW = (n: number) => Math.max(1, Math.min(GRID_COLS, Math.round(n)));
// System-wide widget height ceiling (rows). Tall media tiles (Picture) need
// real height, so this is generous; the canvas simply grows.
export const MAX_WIDGET_H = 16;
const clampH = (n: number) => Math.max(1, Math.min(MAX_WIDGET_H, Math.round(n)));

export function widgetWH(w: { w?: number; h?: number; size?: WidgetSize }): { w: number; h: number } {
  if (typeof w.w === 'number' && typeof w.h === 'number') return { w: clampW(w.w), h: clampH(w.h) };
  if (w.size && SIZE_WH[w.size]) return SIZE_WH[w.size];
  return { w: 4, h: 3 };
}

export type SizeBounds = { minW: number; maxW: number; minH: number; maxH: number };
// Clamp a footprint into a widget's per-type resize bounds (KPI = 1..2 x 1..1).
export function clampToBounds(wh: { w: number; h: number }, b?: SizeBounds): { w: number; h: number } {
  if (!b) return wh;
  return {
    w: Math.max(b.minW, Math.min(b.maxW, wh.w)),
    h: Math.max(b.minH, Math.min(b.maxH, wh.h)),
  };
}

export function resizeToCells(dx: number, dy: number, colW: number, rowH: number, w: number, h: number): { w: number; h: number } {
  const nw = colW > 0 ? w + Math.round(dx / colW) : w;
  const nh = rowH > 0 ? h + Math.round(dy / rowH) : h;
  return { w: clampW(nw), h: clampH(nh) };
}
